import { TextField } from "@mui/material";
import { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import az from "date-fns/locale/az";

export default function InputField({
  formik,
  modalData,
  inputName,
  updateModalState,
}) {
  const [shrink, setShrink] = useState(false);
  registerLocale("az", az);

  const renderDatePicker = (dateName, label) => (
    <div className="render-datepicker">
      <label>
        {label}{" "}
        {(modalData.status === "sold" || dateName === "applicationDate") && (
          <span style={{ color: "red" }}>*</span>
        )}
      </label>

      <DatePicker
        selected={modalData[dateName] ? new Date(modalData[dateName]) : null}
        onChange={(date) => updateModalState(dateName, date)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        placeholderText="dd/mm/yyyy"
        locale="az"
      />
    </div>
  );

  const inputData = [
    {
      inputName: "studentName",
      label: "Ad soyad",
      type: "text",
      inputValue: modalData?.studentName || "",
      // required: true,
    },

    {
      inputName: "email",
      label: "Email",
      type: "email",
      inputValue: modalData?.email || "",
      marginTop: "24px",
      // required: true,
    },

    {
      inputName: "applicationDate",
      label: "Müraciət tarixi",
      type: "date",
      required: true,
      className: "birthday-input date ",
      marginTop: "24px",
    },

    {
      inputName: "nextApplicationDate",
      label: "Növbəti müraciət tarixi",
      type: "date",
      className: "birthday-input ",
      required: true,
      marginTop: "24px",
    },
    // {
    //   inputName: "fin",
    //   label: "Fin",
    //   type: "text",
    //   inputValue: modalData?.fin || "",
    //   marginTop: "24px",
    // },
    {
      inputName: "addInfo",
      label: "Qeyd",
      type: "text",
      inputValue: modalData?.addInfo || "",
      marginTop: "24px",
    },
    {
      inputName: "constDate",
      label: "Konsultasiya tarixi",
      type: "date",
      marginTop: "24px",
      className: "birthday-input",
    },
    // {
    //   inputName: "constTime",
    //   label: "Konsultasiya saatı",
    //   type: "time",
    //   inputValue: modalData?.constTime || "",
    // },
    {
      inputName: "firstContactDate",
      label: "İlk Əlaqə tarixi",
      type: "date",
      className: "birthday-input contact ",
      // required: true,
    },
    {
      inputName: "lastContactDate",
      label: "Son Əlaqə tarixi",
      type: "date",
      className: "birthday-input contact ",
      // required: true,
    },
    {
      inputName: "studentPhone",
      label: "Əlaqə nömrəsi",
      type: "tel",
      inputValue: modalData?.studentPhone || "",
      required: true,
    },

    {
      inputName: "contractDate",
      label: "Müqavilə tarixi",
      type: "date",
      className: "birthday-input",
      marginTop: "24px",
    },
    {
      inputName: "socialMediaName",
      label: "Sosial media adı",
      type: "text",
      marginTop: "24px",
    },

    {
      inputName: "whereComingDescription",
      label: "Mənbə açıqlaması",
      type: "text",
      marginTop: "24px",
    },
  ];

  return (
    <div
      className={
        inputData.find((item) => item.inputName === inputName)?.className || ""
      }
    >
      {inputName === "firstContactDate" ||
      inputName === "lastContactDate" ||
      inputName === "applicationDate" ||
      inputName === "nextApplicationDate" ||
      inputName === "constDate" ||
      inputName === "contractDate" ? (
        renderDatePicker(
          inputName,
          inputName === "firstContactDate"
            ? "İlk əlaqə tarixi"
            : inputName === "lastContactDate"
            ? "Son əlaqə tarixi"
            : inputName === "contractDate"
            ? "Müqavilə tarixi"
            : inputName === "applicationDate"
            ? "Müraciət tarixi"
            : inputName === "nextApplicationDate"
            ? "Növbəti müraciət tarixi"
            : "Konsultasiya tarixi"
        )
      ) : (
        <TextField
          sx={{
            "& input": {
              fontSize: "12px",
              paddingRight: inputData.find(
                (item) => item.inputName === inputName
              )?.paddingRight,
            },
            marginTop: inputData.find((item) => item.inputName === inputName)
              ?.marginTop,
            marginBottom: inputData.find((item) => item.inputName === inputName)
              ?.marginBottom,
            "& .MuiInputLabel-root.Mui-required:after": {
              content: '" *"',
              color: "red",
              fontSize: "12px",
            },
          }}
          InputLabelProps={{
            shrink:
              inputData.find((item) => item.inputName === inputName)?.type ===
                "date" ||
              inputData.find((item) => item.inputName === inputName)?.type ===
                "time"
                ? true
                : inputData.find((item) => item.inputName === inputName)
                    ?.inputValue
                ? true
                : shrink,
            style: {
              fontSize: "12px",
              color: "#3F3F3F",
              marginBottom: inputData.find(
                (item) => item.inputName === inputName
              ).marginBottom,
            },
          }}
          fullWidth
          id={inputName}
          name={inputName}
          type={inputData.find((item) => item.inputName === inputName).type}
          label={inputData.find((item) => item.inputName === inputName).label}
          value={
            inputData.find((item) => item.inputName === inputName)?.inputValue
          }
          onWheel={(e) => e.target.blur()}
          onChange={(e) => updateModalState(inputName, e.target.value)}
          onBlur={(e) => {
            formik.setFieldTouched(inputName, true);
            setShrink(!!e.target.value);
          }}
          onFocus={() => setShrink(true)}
          required={
            inputData.find((item) => item.inputName === inputName)?.required
          }
        />
      )}

      {formik.errors[inputName] && formik.touched[inputName] && (
        <small className="validation-err-message">
          {formik.errors[inputName]}
        </small>
      )}
    </div>
  );
}
